import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpBaseService } from "src/app/base/http-base.service";
import * as LookupDefinitionsActions from '../actions/lookupdefinitions.action';
import { ApiConstants } from '../../base/api-constants';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';

@Injectable()
export class LookupDefinitionsEffects {
    private actions$ = inject(Actions);
    private baseService = inject(HttpBaseService);
    private store = inject(Store);

    getLookupDefinitions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LookupDefinitionsActions.getLookupDefinitions),
            map(action => {
                this.baseService[ApiConstants.getLookupDefinitions.method](
                    ApiConstants.getLookupDefinitions,
                    {
                        tableId: action.tableId
                    }
                ).subscribe(
                    (results: any) => {
                        this.store.dispatch(LookupDefinitionsActions.getLookupDefinitionsSuccess({ payload: results }));
                    },
                    (err: any) => {
                        this.store.dispatch(LookupDefinitionsActions.getLookupDefinitionsFailure({ error: err }));
                    }
                );
            })
        ),
        { dispatch: false }
    );

    saveLookupDefinitions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LookupDefinitionsActions.saveLookupDefinitions),
            map(action => {
                this.baseService[ApiConstants.saveLookupDefinitions.method](
                    ApiConstants.saveLookupDefinitions,
                    action.payload
                ).subscribe(
                    (results: any) => {
                        this.store.dispatch(LookupDefinitionsActions.saveLookupDefinitionsSuccess({ payload: results }));
                    },
                    (err: any) => {
                        this.store.dispatch(LookupDefinitionsActions.saveLookupDefinitionsFailure({ error: err }));
                    }
                );
            })
        ),
        { dispatch: false }
    );

    updateLookupDefinitions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LookupDefinitionsActions.updateLookupDefinitions),
            map(action => {
                this.baseService[ApiConstants.updateLookupDefinitions.method](
                    ApiConstants.updateLookupDefinitions,
                    action.payload
                ).subscribe(
                    (results: any) => {
                        this.store.dispatch(LookupDefinitionsActions.updateLookupDefinitionsSuccess({ payload: results }));
                    },
                    (err: any) => {
                        this.store.dispatch(LookupDefinitionsActions.updateLookupDefinitionsFailure({ error: err }));
                    }
                );
            })
        ),
        { dispatch: false }
    );

    deleteLookupDefinitions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LookupDefinitionsActions.deleteLookupDefinitions),
            map(action => {
                this.baseService[ApiConstants.deleteLookupDefinitions.method](
                    ApiConstants.deleteLookupDefinitions,
                    {
                        lookupdefinitionId: action.lookupdefinitionId
                    }
                ).subscribe(
                    (results: any) => {
                        this.store.dispatch(LookupDefinitionsActions.deleteLookupDefinitionsSuccess({ payload: action.lookupdefinitionId }));
                    },
                    (err: any) => {
                        this.store.dispatch(LookupDefinitionsActions.deleteLookupDefinitionsFailure({ error: err }));
                    }
                );
            })
        ),
        { dispatch: false }
    );

    getLookupDefinitionById$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LookupDefinitionsActions.getLookupDefinitionById),
            map(action => {
                this.baseService[ApiConstants.getLookupDefinitionById.method](
                    ApiConstants.getLookupDefinitionById,
                    {
                        lookupdefinitionId: action.lookupdefinitionId,
                        appId: action.appId
                    }
                ).subscribe(
                    (results: any) => {
                        this.store.dispatch(LookupDefinitionsActions.getLookupDefinitionByIdSuccess({ payload: results }));
                    },
                    (err: any) => {
                        this.store.dispatch(LookupDefinitionsActions.getLookupDefinitionByIdFailure({ error: err }));
                    }
                );
            })
        ),
        { dispatch: false }
    );

}